class BundleBlock extends HTMLElement {
  constructor() {
    super()
    this.type = this.querySelector('.additional-product-block__products').dataset.type
    this.options = this.querySelectorAll('input')
    this.button = this.querySelector('.additional-product-block__button') ? this.querySelector('.additional-product-block__button') : this
    this.hasButton = this.querySelector('.additional-product-block__button') ? true : false
    this.selectedOptionElement = this.closest('.cto-upsell')?.querySelector('.cto-insurance__selected-option') ? this.closest('.cto-upsell').querySelector('.cto-insurance__selected-option') : false

    this.options.forEach(option => {
      option.addEventListener('change', this.handleChangeOption.bind(this))
    })

    if (this.hasButton) {
      this.button.addEventListener('click', this.handleATCButton.bind(this))
    }
    document.addEventListener('price:updated', this.updateMainPriceWithBundles.bind(this))
  }

  handleChangeOption(event) {
    event.preventDefault()
    let input = event.target
    if (this.type == 'one-option') {
      this.options.forEach(option => {
        if (option != input) {
          option.checked = false
        }
      })
    }
    if (this.selectedOptionElement) {
      this.selectedOptionElement.innerHTML = input.dataset.title
    }

    this.handleATCButton('check')
    if (this.checkOptions() && this.button.classList.contains('additional-product-block__button--added')){
      this.updateMainPriceWithBundles('change')
    }
  }

  handleATCButton(action) {
    let actionType = action == 'check' ? action : 'click'
    let productsSelected = this.checkOptions()
    let isChecked = this.button.classList.contains('additional-product-block__button--added')
    if (!isChecked && !productsSelected) return
    if (isChecked) {
      if (actionType == 'click' || productsSelected == false) {
        this.options.forEach(el => {
          el.checked = false
        })
        if (this.hasButton) {
          this.button.innerHTML = this.button.dataset.add
        }
        this.button.classList.remove('additional-product-block__button--added')
        this.updateMainPriceWithBundles('remove')
      }
    } else {
      if (this.hasButton) {
        this.button.innerHTML = this.button.dataset.added
      }
      this.button.classList.add('additional-product-block__button--added')
      this.updateMainPriceWithBundles('add')
    }
  }

  /**
   * Updates the main product price when accessories are added, removed, or changed.
   * All arithmetic is performed in cents (integers) to avoid floating-point errors.
   * The addedPrice dataset attribute stores cents (e.g., 2500 for €25.00).
   * @param {string|Event} operationType - 'add', 'remove', 'change', or Event (from price:updated)
   */
  updateMainPriceWithBundles(operationType) {
    const accessoryCents = Number(this.getSelectedOptionsPrice())
    const priceElements = document.querySelectorAll('.js-product-price-with-care-warranty.actual_price_bold')

    switch (operationType) {
      case 'remove':
        priceElements.forEach(el => {
          const priceEl = el.querySelector('span') || el
          const additionalPriceEl = el.querySelector('.js-cto-dynamic-pricing span') || el.querySelector('.js-cto-dynamic-pricing')
          const currentCents = this.parseEurToCents(priceEl.innerHTML)
          const addedCents = Number(this.dataset.addedPrice) || 0
          const newCents = currentCents - addedCents
          priceEl.innerHTML = this.formatCentsToEur(newCents)
          if (additionalPriceEl) {
            additionalPriceEl.innerHTML = this.formatCentsToEur(newCents)
          }
        })
        this.dataset.addedPrice = ''
        if (this.selectedOptionElement) {
          this.selectedOptionElement.innerHTML = this.selectedOptionElement.dataset.default
        }
        break;
      case 'change':
        priceElements.forEach(el => {
          const priceEl = el.querySelector('span') || el
          const additionalPriceEl = el.querySelector('.js-cto-dynamic-pricing span') || el.querySelector('.js-cto-dynamic-pricing')
          const currentCents = this.parseEurToCents(priceEl.innerHTML)
          const addedCents = Number(this.dataset.addedPrice) || 0
          const baseCents = currentCents - addedCents
          const newCents = baseCents + accessoryCents
          priceEl.innerHTML = this.formatCentsToEur(newCents)
          if (additionalPriceEl) {
            additionalPriceEl.innerHTML = this.formatCentsToEur(newCents)
          }
        })
        this.dataset.addedPrice = accessoryCents
        break;
      case 'add':
        priceElements.forEach(el => {
          const priceEl = el.querySelector('span') || el
          const additionalPriceEl = el.querySelector('.js-cto-dynamic-pricing span') || el.querySelector('.js-cto-dynamic-pricing')
          const currentCents = this.parseEurToCents(priceEl.innerHTML)
          const newCents = currentCents + accessoryCents
          priceEl.innerHTML = this.formatCentsToEur(newCents)
          if (additionalPriceEl) {
            additionalPriceEl.innerHTML = this.formatCentsToEur(newCents)
          }
        })
        this.dataset.addedPrice = accessoryCents
        break;
      default:
        // Triggered by 'price:updated' event — the main price has been
        // reset by main-product.liquid, so re-apply the accessory delta.
        priceElements.forEach(el => {
          const isNMP = el.closest('.net-monthly-pricing')
          if (isNMP) return
          const priceEl = el.querySelector('span') || el
          const additionalPriceEl = el.querySelector('.js-cto-dynamic-pricing span') || el.querySelector('.js-cto-dynamic-pricing')
          const currentCents = this.parseEurToCents(priceEl.innerHTML)
          const newCents = currentCents + accessoryCents
          priceEl.innerHTML = this.formatCentsToEur(newCents)
          if (additionalPriceEl) {
            additionalPriceEl.innerHTML = this.formatCentsToEur(newCents)
          }
        })
        this.dataset.addedPrice = accessoryCents
        break;
    }
    this.updateNMPPricing(operationType)
  }

  /**
   * Updates the Net Monthly Pricing elements.
   * Divides accessory price by the month count (data-price-calculation)
   * before adding/subtracting.
   * @param {string|Event} operationType - 'add', 'remove', 'change', or Event
   */
  updateNMPPricing(operationType) {
    const priceElements = document.querySelectorAll('.js-product-price-with-care-warranty')
    const priceCalculation = Number(priceElements[0]?.dataset?.priceCalculation) || 1
    const accessoryCents = Number(this.getSelectedOptionsPrice())
    const accessoryMonthlyCents = Math.round(accessoryCents / priceCalculation)

    switch (operationType) {
      case 'remove':
        priceElements.forEach(el => {
          const isNMP = el.closest('.net-monthly-pricing')
          if (!isNMP) return
          const priceEl = el.querySelector('span') || el
          const currentCents = this.parseEurToCents(priceEl.innerHTML)
          const addedCents = Number(this.dataset.addedNmpPrice) || 0
          priceEl.innerHTML = this.formatCentsToEur(currentCents - addedCents)
        })
        this.dataset.addedNmpPrice = ''
        break;
      case 'change':
        priceElements.forEach(el => {
          const isNMP = el.closest('.net-monthly-pricing')
          if (!isNMP) return
          const priceEl = el.querySelector('span') || el
          const currentCents = this.parseEurToCents(priceEl.innerHTML)
          const addedCents = Number(this.dataset.addedNmpPrice) || 0
          const baseCents = currentCents - addedCents
          priceEl.innerHTML = this.formatCentsToEur(baseCents + accessoryMonthlyCents)
        })
        this.dataset.addedNmpPrice = accessoryMonthlyCents
        break;
      case 'add':
        priceElements.forEach(el => {
          const isNMP = el.closest('.net-monthly-pricing')
          if (!isNMP) return
          const priceEl = el.querySelector('span') || el
          const currentCents = this.parseEurToCents(priceEl.innerHTML)
          priceEl.innerHTML = this.formatCentsToEur(currentCents + accessoryMonthlyCents)
        })
        this.dataset.addedNmpPrice = accessoryMonthlyCents
        break;
      default:
        priceElements.forEach(el => {
          const isNMP = el.closest('.net-monthly-pricing')
          if (!isNMP) return
          const priceEl = el.querySelector('span') || el
          const currentCents = this.parseEurToCents(priceEl.innerHTML)
          priceEl.innerHTML = this.formatCentsToEur(currentCents + accessoryMonthlyCents)
        })
        this.dataset.addedNmpPrice = accessoryMonthlyCents
        break;
    }
  }

  /**
   * Parses a Spanish EUR formatted price string to cents (integer).
   * Handles format: "1.219,00€" → 121900
   * @param {string|number} price - Price string or number (if already cents)
   * @returns {number} Price in cents as integer
   */
  parseEurToCents(price) {
    if (typeof price === 'number') return Math.round(price)
    // Remove currency symbol (€) and any whitespace (including non-breaking spaces)
    let cleaned = price.replace(/[€\s\u00A0]/g, '').trim()
    // Remove thousands separator (.)
    cleaned = cleaned.replace(/\./g, '')
    // Replace decimal separator (,) with (.)
    cleaned = cleaned.replace(',', '.')
    return Math.round(parseFloat(cleaned) * 100)
  }

  /**
   * Formats cents (integer) to Spanish EUR format: "1.219,00€"
   * Uses dot as thousands separator, comma as decimal, € immediately after.
   * @param {number} cents - Price in cents
   * @returns {string} Formatted price string, e.g. "1.219,00€"
   */
  formatCentsToEur(cents) {
    const value = cents / 100
    const formatted = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)
    // Remove whitespace between number and € to match store format (1.219,00€)
    return formatted.replace(/\s*€/, '€')
  }

  getSelectedOptionsPrice() {
    let price = 0
    this.options.forEach(option => {
      if (option.checked) {
        price += Number(option.dataset.price)
      }
    })
    return price
  }

  checkOptions() {
    let result = false
    this.options.forEach(option => {
      if (option.checked){
        result = true
      }
    })
    return result
  }

  getProductsToAdd() {
    let productsArray = []
    this.options.forEach(option => {
      if (option.checked){
        let obj = {
          id: option.dataset.id,
          quantity: '1',
          properties: {'_uniq_id': String(Date.now() + Math.floor(Math.random() * 300)), '_is_upsell': true, '_item_key': Date.now() + Math.floor(Math.random() * 300)}
        }
        productsArray.push(obj)
      }
    })
    return productsArray.length != 0 ? productsArray : null
  }
}
if (!customElements.get('bundle-block')) {
  customElements.define('bundle-block', BundleBlock);
}